import { CreateDroneRequest } from '../request-models/create-drone-request.model';
import { DroneRequest } from '../request-models/drone-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * Builds the PUT /admin/drones/:id body. Copies only the hub's writable fields (never `status`, ids or
 * timestamps), and only the ones that are set, so an update stays partial. `null` (clear the field) is kept.
 */
export function toDroneRequest(fields: DroneRequest): DroneRequest {
  return omitUndefined<DroneRequest>({
    name: fields.name,
    manufacturerId: fields.manufacturerId,
    modelId: fields.modelId,
    serialNumber: fields.serialNumber,
    packagingSerialNumber: fields.packagingSerialNumber,
    version: fields.version,
    inventoryNote: fields.inventoryNote,
    nNumber: fields.nNumber,
    nNumberActiveDate: fields.nNumberActiveDate,
    remoteId: fields.remoteId,
    remoteBroadcastModule: fields.remoteBroadcastModule,
  });
}

/** Builds the POST /admin/drones body: the writable fields plus the initial `status`, when set. */
export function toCreateDroneRequest(fields: CreateDroneRequest): CreateDroneRequest {
  return omitUndefined<CreateDroneRequest>({ ...toDroneRequest(fields), status: fields.status });
}
